export default "__VITE_ASSET__oe_6Wj7l__"